import React, { useRef } from "react"
import {
  StyledPortionOnly,
  PortionLabel,
  StyledUnit,
} from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import DisplayedGramAndCaloriesPerUnit from "components/Common/DisplayedGramAndCaloriesPerUnit"
import PortionIcon from "components/Icons/PortionIcon"
import PortionInput from "components/foodDetails/share/PortionInput"

export interface IPortionOnlyProps {
  portionValue: number
  onPortionChange: (portion: number) => void
  unit: string
  style?: React.CSSProperties
  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  gram: null | number
}

const PortionOnlyFormItem = (props: IPortionOnlyProps) => {
  const {
    onPortionChange,
    portionValue,
    unit,
    style = {},
    disabled,
    setIsPortionValid,
    calories,
    gram,
  } = props

  const firstInputRef = useRef<HTMLInputElement>(null)

  return (
    <StyledPortionOnly style={style}>
      <FlexBox
        $justify="space-between"
        $alignItems="center"
        $gap={12}
        style={{ width: "100%" }}
      >
        <FlexBox $alignItems="center" $gap={4}>
          <PortionIcon />
          <PortionLabel>Portion</PortionLabel>
        </FlexBox>

        <FlexBox $alignItems="center" $gap={12}>
          <PortionInput
            width={80}
            disabled={disabled}
            ref={firstInputRef}
            value={portionValue}
            onChange={onPortionChange}
            setIsPortionValid={setIsPortionValid}
          />

          <StyledUnit>{`${unit}(s)`}</StyledUnit>
        </FlexBox>
      </FlexBox>

      <DisplayedGramAndCaloriesPerUnit
        calories={calories}
        portion={portionValue}
        unit={unit}
        gram={gram}
      />
    </StyledPortionOnly>
  )
}

export default PortionOnlyFormItem
